// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "platform-host/" + chunkId + "-" + {1743: "2766a9adda62b469",4144: "97b84bac8c76c1a4",5947: "a65961fbd4b5f0c1",7355: "4ca4d72ca9039ad8",}[chunkId] + ".css"
}